export default __webpack_public_path__ + "static/media/goopter-use-case-hotel-service-automation-highlights.a2c865f9.jpg";